import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import {validatable} from 'components/utils';

class DropDownChonNganhLinhVuc extends React.Component {
  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown label={this.props.label} bindValidator={this} channel="formTaoDon" selectedValue={this.props.selectedValue} require={this.props.require} isValid={this.props.isValid} options={this.props.data} keyName='giaTri' valueName='ten' onChange={this.onChange.bind(this)} placeholder={this.props.placeholder} className={'col-input '+this.props.className} name={this.props.name}/>
    )
  }
}

DropDownChonNganhLinhVuc.defaultProps = {
  className: 'input-group',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  label: "Kết luận nội dung khiếu nại",
  name:'dropdownChonKetLuanNoiDungGiaoTTXM'
}

let bindStateToProps = state => {
  return {
    data: [
      {giaTri: 'Dệt may', ten: 'Dệt may'},
      {giaTri: 'Điện', ten: 'Điện'},
      {giaTri: 'Vui chơi, giải trí', ten: 'Vui chơi, giải trí'},
      {giaTri: 'Thể thao', ten: 'Thể thao'}
    ]
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonNganhLinhVuc));


// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonnganhlinhvuc.jsx